import React, { Component } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { Container } from 'reactstrap'
import { AppAside, AppBreadcrumb, AppFooter, AppHeader, AppSidebar, AppSidebarFooter, AppSidebarForm, AppSidebarHeader, AppSidebarMinimizer, AppSidebarNav, } from '@coreui/react'
import Axios from 'axios';

// sidebar nav config
import navigation from '../../_nav'
import NonAdminnavigation from '../../_nonAdnav'
import Guestnavigation from '../../_navGuest'
import { firebase } from '../../config/firebase'

// routes config
import routes from '../../routes'
import DefaultAside from './DefaultAside'
import DefaultFooter from './DefaultFooter'
import DefaultHeader from './DefaultHeader'

class DefaultLayout extends Component {

  constructor(props) {
    super(props)
    const AdminOption = localStorage.getItem('ADMINSTATUS')
    const train_pass = localStorage.getItem('train_pass')
    const HOSPITAL = localStorage.getItem('HOSPITAL')
    const email = localStorage.getItem('email')

    this.state = {
      istrainPass: train_pass,
      isAdmin: AdminOption,
      HOSPITAL: HOSPITAL,
      email: email,
    }
  }
  
  async componentDidMount() {
    await firebase.auth().onAuthStateChanged(async (user) => {
      if (!!user) {
        const preresponse = await firebase.database().ref("User").child(user.displayName).once('value')
        let response = await preresponse.child('AdminOption').val()
        if (response && response === 'No') {
          const navIndex = navigation.items.findIndex(data => data.name === 'Edit Ward')
          navigation.items[navIndex].url = '#'
        }
      }
    })
  }

  render() {
    
    // const istrainPass = this.state.istrainPass;
    let SideNav;
    if (this.state.istrainPass === 'no' || this.state.istrainPass === 'No') {
      SideNav = <AppSidebarNav navConfig={Guestnavigation} {...this.props} />;
    } else {
      if (this.state.isAdmin === 'yes' ||this.state.isAdmin === 'Yes' ||this.state.isAdmin === 'mainAdmin'
      ||this.state.email ==='icnrama2014@gmail.com'||this.state.email === 's.kanabadee@gmail.com'){
        SideNav = <AppSidebarNav navConfig={navigation} {...this.props} />;
      } else{
        SideNav = <AppSidebarNav navConfig={NonAdminnavigation} {...this.props} />;
      }
      // if (this.state.HOSPITAL==='ramathibodi' ){
      //   if (this.state.email !=='icnrama2014@gmail.com' && this.state.email !== 's.kanabadee@gmail.com'){
      //     SideNav = <AppSidebarNav navConfig={Guestnavigation} {...this.props} />;
      //   }
      // }
      
    }

    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader />
        </AppHeader>
        <div className="app-body"style={{backgroundColor: "#e8ecef"}}>
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            {SideNav}
            
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <main className="main">
            <AppBreadcrumb appRoutes={routes} />
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                  return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                    <route.component {...props} />
                  )} />)
                    : (null)
                },
                )}
                <Redirect from="/" to="/dashboard" />
              </Switch>
            </Container>
          </main>
          <AppAside fixed hidden>
            <DefaultAside />
          </AppAside>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>
      </div>
    )
  }
}

export default DefaultLayout



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js